import React from 'react';
import { Controller } from 'react-hook-form';

import { Dropdown } from 'components';

// Dropdown constroller to be used on a React Hook form
const DropdownController = ({ control, onChange, name, ...dropdownProps }) => {
  return (
    <Controller
      control={control}
      name={name}
      render={(form) => (
        <Dropdown
          onSelectOption={(option) => {
            onChange && onChange(option.id);
            form.onChange(option.id);
            form.onBlur();
          }}
          selectedOptionId={form.value}
          name={form.name}
          {...dropdownProps}
        />
      )}
    />
  );
};

export { DropdownController };
